import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  orderedWeiterbildungsarten,
  orderedWeiterbildungsartenWeiterbildungsangebote,
  Weiterbildungsart
} from '../../../model/weiterbildungsarten';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({ providedIn: 'root' })
export class WeiterbildungsartUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'sys';

  constructor() {
    super(WeiterbildungsartUrlService.URL_PARAMETER, 'wbArt');
  }

  public override get selectedOptionIds$(): Observable<string[]> {
    return this.selectedOptions$.pipe(map(this.mapSystematikenToIds), map(this.mapIdsToBackendIds));
  }

  /**
   * Mappt Systematiken zu IDs (welche in der URL angezeigt werden)
   * Falls eine SystematikId übergeben wird, wird sie in eine normale ID gemappt,
   * wenn bereits eine normale ID übergeben wurde, wird sie 1:1 zurück gegeben.
   * @param systematikIds Array von IDs von Systematiken oder normale Ids
   * @returns Array von IDs
   */
  private mapSystematikenToIds(systematikIds: string[]): string[] {
    const ids = systematikIds.map((systematikId) => {
      const weiterbildungsartFromSystematikId =
        orderedWeiterbildungsartenWeiterbildungsangebote.find((a) =>
          a.systematikIds?.includes(systematikId)
        )?.id;

      return (weiterbildungsartFromSystematikId as string) || systematikId;
    });
    // remove duplicates
    return [...new Set(ids)];
  }

  /**
   * Mappt IDs (aus der URL) zu backendIds (Kommunikation zw. UI und Backend)
   * @param ids Array von IDs
   * @returns Array von Backend-IDs (Weiterbildungsart enum)
   */
  private mapIdsToBackendIds(ids: string[]): Weiterbildungsart[] {
    return ids
      .map((id) => orderedWeiterbildungsarten.find((option) => option.id === id)?.backendId || null)
      .filter((item) => !!item);
  }
}
